import React from 'react';
import { Grid } from 'semantic-ui-react';
import { hasMinimumLength } from '@/utils/resultsHelper';
import { translatedError } from '@/utils/errors';
import fields, { fieldLengths } from '@/constants/fields';
import DatasourceInputField from './DatasourceInputField';

export const validateDatasourceDatabaseFieldsForTest = (settings) => {
  const errors = [];

  if (!hasMinimumLength(settings.host)) {
    errors.push(translatedError(
      'dataset.datasource',
      null,
      'validation.host.required',
      [fields.HOST],
    ));
  }

  if (!hasMinimumLength(settings.name)) {
    errors.push(translatedError(
      'dataset.datasource',
      null,
      'validation.name.required',
      [fields.NAME],
    ));
  }

  if (!hasMinimumLength(settings.username)) {
    errors.push(translatedError(
      'dataset.datasource',
      null,
      'validation.username.required',
      [fields.USERNAME],
    ));
  }

  if (!hasMinimumLength(settings.password)) {
    errors.push(translatedError(
      'dataset.datasource',
      null,
      'validation.password.required',
      [fields.PASSWORD],
    ));
  }

  return errors;
};

export const validateDatasourceDatabaseFields = (settings, errors) => {
  errors.push(...validateDatasourceDatabaseFieldsForTest(settings));
  if (settings.host && settings.host.length > fieldLengths.medium) {
    errors.push(translatedError(
      'dataset.datasource',
      'save.dataset.datasource.validation.host.title',
      'validation.max.length',
      [fields.HOST],
      { maximum: fieldLengths.medium },
    ));
  }

  if (settings.name && settings.name.length > fieldLengths.medium) {
    errors.push(translatedError(
      'dataset.datasource',
      'save.dataset.datasource.validation.name.title',
      'validation.max.length',
      [fields.NAME],
      { maximum: fieldLengths.medium },
    ));
  }

  if (settings.username && settings.username.length > fieldLengths.medium) {
    errors.push(translatedError(
      'dataset.datasource',
      'save.dataset.datasource.validation.username.title',
      'validation.max.length',
      [fields.USERNAME],
      { maximum: fieldLengths.medium },
    ));
  }

  if (settings.password && settings.password.length > fieldLengths.large) {
    errors.push(translatedError(
      'dataset.datasource',
      'save.dataset.datasource.validation.password.title',
      'validation.max.length',
      [fields.PASSWORD],
      { maximum: fieldLengths.large },
    ));
  }
};

const DatasourceDatabaseFields = ({ disabled, settings, updateSettings }) => (
  <>
    <Grid.Row>
      <DatasourceInputField
        disabled={disabled}
        entity="host"
        field={fields.HOST}
        onChange={(value) => updateSettings({ host: value })}
        saveErrors={settings.saveErrors}
        text={settings.host}
      />
      <DatasourceInputField
        disabled={disabled}
        entity="name"
        field={fields.NAME}
        onChange={(value) => updateSettings({ name: value })}
        saveErrors={settings.saveErrors}
        text={settings.name}
      />
    </Grid.Row>
    <Grid.Row>
      <DatasourceInputField
        disabled={disabled}
        entity="username"
        field={fields.USERNAME}
        onChange={(value) => updateSettings({ username: value })}
        saveErrors={settings.saveErrors}
        text={settings.username}
      />
      <DatasourceInputField
        disabled={disabled}
        entity="password"
        field={fields.PASSWORD}
        maxLength={fieldLengths.large}
        onChange={(value) => updateSettings({ password: value })}
        saveErrors={settings.saveErrors}
        text={settings.password}
        type="password"
      />
    </Grid.Row>
  </>
);

export default DatasourceDatabaseFields;
